export default __webpack_public_path__ + "static/media/php.a8dd7318.svg";